import { Dialog } from "@mui/material";
import DocUpload from "./DocUpload";

export default function DocUploadDialog({ actorId, files, type, open, onClose }) {
  if (!open) {
    return null;
  }

  return (
    <Dialog maxWidth={false} className="stdDialog mediumCourseDialog" scroll="paper" onClose={onClose} open={open}>
      <DocUpload actorId={actorId} files={files} type={type} onClose={onClose} />
    </Dialog>
  );
}
